import React from 'react';

export default function ViewCarePlan() {
  return <div className="card axs-shadow mt-4">
    <div className="card-header">
      <div className="row">
        <div className="col">
          <h6>Care Plan</h6>
        </div>
      </div>
    </div>
    <div className="card-body">
      <h6>Care Plan not provided.</h6>
    </div>
  </div>
}